/* istanbul ignore file */

import { DISPLAY_LOADER } from '../reducerConstants';

export function DisplayLoader(data) {
    return dispatch => {
        dispatch({ type: DISPLAY_LOADER, data: data });
    }
}